module.exports = __webpack_public_path__ + "static/media/img-vision.23eef740.png";